<template>
  <div class="">
      <!-- Seller Picture -->
      <v-card>
        <v-card-title primary-title>
              <div>
                Profile picture<br />

              </div>
        </v-card-title>

        <v-layout wrap>
          <v-flex class="md4 sm8 xs12">
            <ImageDrop ref="imageDrop" @newFile="newFile" :src="downloadURL" style=""></ImageDrop>
          </v-flex>
          <v-flex class="subheading sm4 xs12 pl-2">
            Drag and drop a new picture or
            <br />
            <FileSelect v-on:fileSelected="fileSelected"></FileSelect>
            <br /><br />

            <v-btn :disabled="!profilePic" @click="editPicture"><v-icon class="mr-1">{{$vuetify.icons.edit}}</v-icon>Edit Picture</v-btn>
            <br />
            <v-btn :disabled="!profilePic" @click="removePictureConfirm"><v-icon class="mr-1">{{$vuetify.icons.delete}}</v-icon>Remove Picture</v-btn>

            <div v-if="errMessage" class="error--text">
              {{errMessage}}
            </div>
          </v-flex>
        </v-layout>

        <span v-if="!profilePic">You have no picture in your profile. You can add one so people know who you are.</span>

      </v-card>
      <LoadingDialog :show="savingInProgress" :progress="savingProgress" text="Saving changes..." ></LoadingDialog>
      <v-dialog v-model="imgEditorDialog" lazy >
        <v-card>
          <v-container fluid>

            <MiniPaint
                :ref="minipaintID"
                :img="currentImg"
                :imgChanged="imgChanged"
                @cancel="cancelMiniPaint"
                >
            </MiniPaint>
       </v-container>
       </v-card>

      </v-dialog>

</div>

</template>

<script>

import {mapState} from 'vuex'
import ProfilePicture from '../../common/ProfilePicture'
import ImageDrop from '../ImageDrop'
import MiniPaint from '../MiniPaint'
import FileSelect from '../FileSelect'
import LoadingDialog from '../../common/LoadingDialog'
import utils from '../../../utils.ts'
import firebase from 'firebase/app'
const uuidv1 = require('uuid/v1')

export default {
  name: 'SellerPictureCard',
  components: {
    ProfilePicture, ImageDrop, FileSelect, LoadingDialog, MiniPaint
  },
  computed: {
    ...mapState({
      profilePic: state => state.admin.public_settings.profilePic,
      locked: state => state.admin.public_settings.locked
    }),
    downloadURL () {
      if (this.profilePic) {
        return this.profilePic.downloadURL
      } else {
        return null
      }
    }
  },
  props: {

  },
  data () {
    return {
      savingInProgress: false,
      savingProgress: 0,
      updateSuccess: false,
      errMessage: null,
      currentImg: null,
      imgEditorDialog: false,
      minipaintID: 'minipaintSPC'
    }
  },
  watch: {
    profilePic () {
      if (this.profilePic !=  null && this.currentImg == null) {
        this.currentImg = this.profilePic
      }
    }
  },
  mounted: function () {
    console.log('Seller pic mounted: ' + this.currentImg)
    console.log('Seller pic mounted PRO: ' + this.profilePic)
    if (this.currentImg === null) {
      this.currentImg = this.profilePic
    }
  },
  methods: {
    newFile: async function (fileInfo) {

      if (this.locked) {
        this.errMessage = "This account is locked. You cannot make changes."
        return
      }

      this.savingInProgress = true
      this.savingProgress = 10
      console.log('SellerPic new file ' + fileInfo.fileName)

      this.currentImg = {
        imgBlob: fileInfo.imgBlob,
        fileName: fileInfo.fileName
      }

      // Immediately update the database (there is no save button)

      // Remove the old file
      await this.removePictureFromStorage()
      this.savingProgress = 20

      // Create Thumbnail and Upload Files
      const imgPath = [this.uid, 'image', uuidv1()].join('/')
      const thumbFileName = 'thumb_' + this.currentImg.fileName
      const downloadURL = utils.uploadImgBlob(this.currentImg.imgBlob, imgPath, this.currentImg.fileName) // This is a promise
      const smallImg = utils.thumbnailify(this.currentImg.imgBlob, 100, true)
      const thumbDownloadURL = smallImg.then((thumbBase64img) => {
        console.log('DEBUG : thumbnailfy is done')
        return utils.uploadBase64Img(thumbBase64img, imgPath, thumbFileName) // This is a promise also
      })
      console.log('Waiting for uploads to finish....')
      const dlURL = await downloadURL
      console.log('DL url done: ' + dlURL)
      await thumbDownloadURL
      console.log('Thumb url done')

      const urls = await Promise.all([downloadURL, thumbDownloadURL])
      console.log('Waiting for uploads to finish....DONE')
      this.savingProgress = 70
      // Update the DB
      const newData = {
        'downloadURL': urls[0],
        'thumbDownloadURL': urls[1],
        'imgPath': imgPath,
        'fileName': this.currentImg.fileName,
        'thumbFileName': thumbFileName
      }

      return this.updateDatabase(newData)
    },
    fileSelected: function (theFiles) {
      // A file was chosen, do something with it!
      console.log('File Select: ' + theFiles)
      this.$refs.imageDrop.handleFiles(theFiles)
    },
    editPicture: function () {
      this.imgEditorDialog = true

      // Now we load it?
      const func = () => {
        if (this.$refs[this.minipaintID]) {
          this.$refs[this.minipaintID].load()
        } else {
          window.setTimeout(func, 100)
        }
      }

      func()
    },
    cancelMiniPaint: function () {
      this.imgEditorDialog = false
    },
    imgChanged: function (newDataURL) {
      // this.dialog = false
      // this.forceUpdate += 1
      // this.fileChanged = true

      const newData = {
        imgBlob: newDataURL
      }
      if (this.currentImg) {
        newData.fileName = this.currentImg.fileName
      } else if (this.profilePic) {
        newData.fileName = this.profilePic.fileName
      }

      // Now go back to the SellerPage
      this.imgEditorDialog = false
      this.newFile(newData)
    },
    removePictureConfirm: function () {
      this.$confirm(`Are you sure you want to delete this picture?`).then(async res => {
        if (res) {
          if (this.locked) {
            this.errMessage = "This account is locked. You cannot make changes."
          } else {
            this.removePicture()
          }

        }
      })
    },
    removePictureFromStorage () {
      if (this.profilePic) {
        const p1 = utils.removeFile(this.profilePic.imgPath, this.profilePic.fileName)
        const p2 = utils.removeFile(this.profilePic.imgPath, this.profilePic.thumbFileName)
        return Promise.all([p1, p2])
      } else {
        return Promise.resolve(true)
      }
    },
    removePicture: async function () {
      if (!this.profilePic) {
        this.errMessage = 'No picture is there to remove'
      }

      // Now try and remove the picture from everywhere.
      this.removePictureFromStorage().catch((err) => {
        if (err.code === 'storage/object-not-found') {
          console.log('Warning: Picture to remove was not found. Continuing.')
          return true
        } else {
          throw err
        }
      }).then(() => {
        // Now delete from the Database
        const settingsRef = firebase.firestore()
          .collection('artists')
          .doc(firebase.auth().currentUser.uid)
          .collection('public')
          .doc('settings')

        return settingsRef.update({
          profilePic: firebase.firestore.FieldValue.delete()
        })
      }).catch((err) => {
        console.log('Error removing picture!' + err)
        this.errMessage = err
      })
    },
    updateDatabase: async function (data) {
      /*
      Data is:
        'downloadURL': downloadURL,
        'thumbDownloadURL': thumbDownloadURL,
        'imgPath': imgPath,
        'fileName': file.name,
        'thumbFileName': thumbFileName
      */

      // Update the ProfilePic value
      this.errMessage = null
      this.updateSuccess = false

      try {
        // Do Update
        const settingsRef = firebase.firestore()
          .collection('artists')
          .doc(firebase.auth().currentUser.uid)
          .collection('public')
          .doc('settings')

        await settingsRef.set({
          profilePic: data
        }, {merge: true})

        // If all went well, we're logged in as the kid, go to their account
        this.updateSuccess = true
      } catch (err) {
        console.error('Could not update the picture: ' + JSON.stringify(err))
        this.errMessage = err.message
      }
      this.savingProgress = 100

      this.savingInProgress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
